module.exports = __webpack_public_path__ + "static/img/memberLDL.6f80189.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investTeam/memberLDL.png
// module id = zjHG
// module chunks = 0